import React, { useState } from 'react';
import './style.scss';
import HomeNftDescButton from '../description/button';
import Button from '../../../../controls/button';
import { API_OwnNft } from 'shared';
import clsx from 'clsx';

type FunctionWithCB = (stopLoading?: () => any) => any;

interface Props {
  nft: API_OwnNft;
  updateStatus: FunctionWithCB;
  removeNft: FunctionWithCB;
  className: string;
  fullWidth?: boolean;
}

const FightPickControls = ({
  nft,
  removeNft,
  updateStatus,
  className,
  fullWidth
}: Props) => {
  const [removeLoading, setRemoveLoading] = useState(false);

  const handleRemoveClick = () => {
    setRemoveLoading(true);
    removeNft(() => setRemoveLoading(false));
  };

  return (
    <div
      className={clsx('home-nft-controls', fullWidth && 'fullwidth', className)}
    >
      <h5
        className={clsx(
          'home-nft-controls-hint',
          (nft.failed || nft.pending) && 'home-nft-controls-hint-visible'
        )}
      >
        {nft.pending ? (
          'Transaction Pending'
        ) : nft.failed ? (
          'Transaction Failed!'
        ) : (
          <br />
        )}
      </h5>
      <div className='home-nft-controls-buttons'>
        <HomeNftDescButton nft={nft} update={updateStatus} />
        {nft.failed && (
          <Button
            color='secondary'
            variant='contained'
            loading={removeLoading}
            onClick={handleRemoveClick}
          >
            Remove From Gang
          </Button>
        )}
      </div>
    </div>
  );
};

export default FightPickControls;
